import { validatorsRepository } from "@frui.ts/validation";
import { observable, runInAction } from "mobx";
import { availableLocales } from "../../config";
import AuthorizationService from "../authorizationService";
import LocaleProvider from "../localeProvider";
import LocalizationService from "../localizationService";
import { IInitializationService } from "./types";
import ValidationService from "../validationService";

export default class BasicInitializationService implements IInitializationService {
  @observable isInitialized: boolean;

  constructor(
    private localeProvider: LocaleProvider,
    private localizationService: LocalizationService,
    private validationService: ValidationService,
    private authorizationService: AuthorizationService
  ) {
    this.isInitialized = false;
  }

  async initialize(defaultLanguage?: string) {
    this.validationService.initialize(validatorsRepository as any);
    this.localeProvider.initialize(availableLocales, defaultLanguage);
    this.authorizationService.initialize();

    await Promise.all([this.localizationService.initialize()]);

    runInAction(() => (this.isInitialized = true));
  }
}
